export default __webpack_public_path__ + "static/media/icon-awesome-spinner.3e3ffbcd.svg";